import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { I18nModule } from "@spartacus/core";
import { provideOutlet, OutletPosition } from "@spartacus/storefront";
import { ChatbotComponent } from "./chatbot/chatbot.component";

@NgModule({
  declarations: [ChatbotComponent],

  providers: [
    provideOutlet({
      id: 'Footer',
      position: OutletPosition.AFTER,
      component: ChatbotComponent,
    }),
  ],
  imports: [
    CommonModule,
    I18nModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
  ]
})
export class ChatbotModule { }
